import { useCallback } from "react";
import { useOnboardingState } from "../features/onboarding/useOnboardingState";
import {
  useBackMutation,
  useNextMutation,
  useStartMutation,
} from "./onboardingApi";

export const useOnboardingApi = () => {
  const [startFn] = useStartMutation();
  const [nextFn] = useNextMutation();
  const [backFn] = useBackMutation();

  const {
    isError,
    lastAction,
    currentStep,
    data,
    stepValues,
    isLoading,
    isSuccess,
    error,
    errorCode,
    redirectError,
  } = useOnboardingState();

  const processId = data?.processId ?? "";

  const start = useCallback(
    (queryString: string, analyticsId?: string, productType?: string) => {
      return startFn({
        queryString,
        analyticsId,
        productType,
      });
    },
    [startFn],
  );

  const back = useCallback(() => {
    return backFn({
      stepId: currentStep - 1,
      processId,
    });
  }, [backFn, currentStep, processId]);

  const next = useCallback(
    async (values: Record<string, unknown>) => {
      if (data && values) {
        return nextFn({
          stepId: currentStep + 1,
          data,
          values,
        });
      }
    },
    [data, nextFn, currentStep],
  );

  return {
    isError,
    lastAction,
    isLoading,
    isSuccess,
    lastValues: stepValues,
    data,
    error,
    errorCode,
    processId,
    start,
    back,
    next,
    redirectError,
  };
};
